export const Download = () => {
  // Usa la impresión nativa del navegador ("Guardar como PDF").
  // Produce texto real y seleccionable y respeta los cortes de página
  // definidos en el @media print de index.css (no parte palabras).
  const printDocument = () => window.print();

  return (
    <button
      onClick={printDocument}
      className="mr-4 px-3 py-1 border rounded font-mono text-sm hover:bg-gray-100"
    >
      PDF download
    </button>
  );
};
